<template>
  <div class="min-h-screen flex items-center justify-center bg-slate-50 p-6">
    <div class="max-w-2xl w-full rounded-2xl border border-slate-200 bg-white p-8 shadow-sm text-center">
      <div v-if="isTrialExpired">
        <div class="mx-auto mb-4 h-14 w-14 rounded-full bg-blue-100 flex items-center justify-center">
          <span class="material-symbols-outlined text-blue-700 text-3xl">timer_off</span>
        </div>
        <h1 class="text-2xl md:text-3xl font-semibold text-slate-900">Período de prueba finalizado</h1>
        <p class="mt-3 text-slate-600">
          Los 7 días de prueba gratuita de <strong>{{ inmobiliariaNombre }}</strong> han expirado.
        </p>
        <p class="mt-2 text-slate-600">
          Para seguir usando Inmob, contratá el plan Básico desde el panel de facturación.
        </p>
        <div class="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <a :href="billingUrl"
             class="inline-flex items-center justify-center px-6 py-3 bg-blue-700 text-white font-semibold rounded-xl hover:bg-blue-800 transition-colors">
            Ir a Facturación
          </a>
        </div>
      </div>
      <div v-else>
        <div class="mx-auto mb-4 h-12 w-12 rounded-full bg-amber-100 flex items-center justify-center">
          <span class="text-amber-700 text-2xl">!</span>
        </div>
        <h1 class="text-2xl md:text-3xl font-semibold text-slate-900">Sitio temporalmente no habilitado</h1>
        <p class="mt-3 text-slate-600">
          La inmobiliaria
          <strong>{{ inmobiliariaNombre || 'seleccionada' }}</strong>
          no tiene una suscripción activa.
        </p>
        <p class="mt-2 text-slate-600">
          Para habilitar este sitio, el administrador debe activar o regularizar la suscripción.
        </p>
        <p class="mt-6 text-sm text-slate-500">
          Si creés que esto es un error, por favor contactá al administrador de la inmobiliaria.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SubscriptionInactiveGate',
  computed: {
    ...mapState({
      accessControl: state => state.accessControl,
    }),
    inmobiliariaNombre() {
      return this.accessControl?.inmobiliaria?.nombre || ''
    },
    isTrialExpired() {
      return this.accessControl?.reason === 'trial_expired'
    },
    billingUrl() {
      const base = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000'
      return `${base}/panel-admin/facturacion/`
    },
  },
}
</script>
